<template>
   <div>
    <div class="row">
        <div class="col-sm-12 col-md-12 mb-1">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                    <input
                        type="text"
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"
                        @keyup.enter="getAllMessages"
                    />
                    <div class="input-group-append">
                        <MdButton
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="getAllMessages"
                        >
                        </MdButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="flex-container">
            <div class="row">
                    <b-col lg="3" md="3" sm="12">
                        <MdDateTime
                            :Label="$t('Shared.datefrom')"
                            :Model="DateFrom"
                            @input="InputDateFrom($event)"
                            :Id="'NoticeDateFrom'"
                            :Type="'date'"
                            :isRequired="false"
                            :isConfirm="false"
                        >
                        </MdDateTime>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdDateTime
                            :Label="$t('Shared.dateTo')"
                            :Model="DateTo"
                            @input="InputDateTo($event)"
                            :Id="'NoticeDateTo'"
                            :Type="'date'"
                            :isRequired="false"
                            :isConfirm="false"
                        >
                        </MdDateTime>
                    </b-col>
                    <b-col lg="3" md="3" sm="12" v-if="IsFilterPatient">
                        <MdLookupMultiSelect
                                v-bind:Label="$tc('Shared.Patient', 2)"
                                v-bind:ModelCode="PatientModel"
                                v-bind:RefCode="'patientcode'"
                                v-bind:Api="'Patients'"
                                v-bind:FieldCode="'patientcode'"
                                v-bind:FieldDescription="'firstname'"
                                :SearchTitle="$tc('Shared.Patient', 2)"
                                :GetValues="getPatientValues"
                                :InvalidFeedback="$t('Msg.InvalidCode')"
                                :SearchFieldCode="'PatientCode'"
                                :AuxFields="patientAuxFields"
                                :FieldsDate="patientFieldsDate"
                                :ServerSidePagination="true"
                                v-bind:Fields="patientLookupFields"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12" v-if="IsFilterRecipientType">
                        <MdSelect
                            v-bind:Label="'Recipient Type'"
                            v-bind:Options="RecipientTypeList"
                            v-bind:ModelArray="RecipientTypeModel"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'value'"
                            v-bind:Placeholder="selectPlaceholder"
                            :Input="ChangeDropDownRecipientType"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12" v-if="IsFilterModule">
                        <MdSelect
                            v-bind:Label="'Module'"
                            v-bind:Options="ModuleList"
                            v-bind:ModelArray="ModuleModel"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'value'"
                            v-bind:Placeholder="selectPlaceholder"
                            :Input="ChangeDropDownModule"
                        />
                    </b-col>

            <b-col lg="3" md="3" sm="12" v-if="IsFilterNotificationType">
                 <MdSelect
                    v-bind:Label="'Notification Type'"
                    v-bind:Options="NotificationTypeList"
                    v-bind:ModelArray="NotificationTypeModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    :Input="ChangeDropDownNotificationType"
                />
            </b-col>

             <b-col lg="3" md="3" sm="12" v-if="IsFilterStatus">
                 <MdSelect
                    v-bind:Label="'Status'"
                    v-bind:Options="StatusList"
                    v-bind:ModelArray="StatusModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    :Input="ChangeDropDownStatus"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12" v-if="IsFilterAction">
                 <MdSelect
                    v-bind:Label="'Action'"
                    v-bind:Options="ActionList"
                    v-bind:ModelArray="ActionModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    :Input="ChangeDropDownAction"
                />
            </b-col>

            </div>
             <div class="row justify-content-end">
                        <MdButton
                            v-bind:Label="$t('Shared.Search')"
                            v-bind:Name="'btnsearchNotifications'"
                            v-bind:ClassProp="'secondary mr-3 btn-login'"
                            v-on:click="getAllMessages"
                        />
                    </div>
            </div>

        <div class="row">
            <div class="col-12">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="refTable"
                        v-bind:FieldsDate="FieldsDateArr"
                        v-bind:ondblClick="handleDblClick"
                        :IsPatientNotification="true"
                        :viewIconEvent="handleViewEvent"
                        :onRowSelected="onRowSelected"
                        :onFiltered="onFiltered"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction">
                    </MdTable>
            </div>
        </div>


        <BaseModal
          v-if="VisibleMessage"
          ModalId="ModalNotificationMessage"
          :key="'ModalNotificationMessage'"
          :TitleWindow="'Message'"
          :width="'60%'"
          :height="'40vh'"
          :UseUpClass="true"
          :HideModalFun="MessageOnCancel"
          @Close="MessageOnCancel"
          :buttons="[
              { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }
          ]">

        <MdRichEdit
            v-model="Message"
            v-bind:isReadOnly="true"
            v-bind:Height="'40vh'"
            v-bind:id="'edit_memoInfo'"
            v-bind:isRequired="false"
            v-bind:HideToolBar="true"
            v-bind:StartupFocus="false"
        />
      </BaseModal>


   </div>
</template>

<script>
import MessageHistory from '@/services/messagehistories.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
import EnumService from '@/services/enum.service'


export default {
  name: 'Notices',
  mixins: [ShowMessage, DBFunctions],

  props:{
    PatientCode:String,
    IsFilterPatient:{
        type: Boolean,
        default: true
    },
    IsFilterRecipientType:{
        type: Boolean,
        default: true
    },
    IsFilterModule:{
        type: Boolean,
        default: true
    },
    IsFilterStatus:{
        type: Boolean,
        default: true
    },
    IsFilterAction:{
        type: Boolean,
        default: true
    },
    IsFilterNotificationType:{
        type: Boolean,
        default: true
    },
  },
  components:{},
  data(){
    return {
      VisibleMessage:false,
      DateFrom:null,
      DateTo:null,
      dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
      RecipientTypeList:[],
      ModuleList:[],
      StatusList:EnumService.NotificationStatus,
      ActionList:[],
      NotificationTypeList:EnumService.NotificationType,
      RecipientTypeModel:{},
      StatusModel:{value:"",name:""},
      NotificationTypeModel:{value:"",name:""},
      ActionModel:{},
      PatientModel:[],
      ModuleModel:{},
      pageOptions: [5, 10, 15 ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      Message:null,
      items: [],
      selected: [],
      ShowMessageIsEmpty:false,
      FieldsDateArr:[],
      patientAuxFields: ['lastname'],
      patientFieldsDate: ['dob'],
      patientLookupFields: [
        { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
        { key: 'lastname', sortable: true, label: this.$t('Shared.LastName') },
        { key: 'patientcode', sortable: true, label: this.$t('Shared.Code') },
        { key: 'dob', sortable: true, label: this.$t('Shared.Dob') }
      ],
      parameter:{
        PatientCodeList: [],
        RecipientTypeList: [],
        ModuleList: [],
        ActionList: [],
        NotificationTypeList: [],
        StatusList: [],
        DateFrom:null,
        DateTo:null,
        SearchCriteria:"",
      },
      selectPlaceholder: this.$t('Clinical.SelectOptions'),
      fields: [
            { key: 'sysDate', sortable: true, label: 'Date', class: 'text-rigth' },
            { key: 'patientName', sortable: true, label: 'Patient Name', class: 'text-rigth' },
            { key: 'recipientContact', sortable: true, label: 'Recipient Contact', class: 'text-rigth' },
            { key: 'patientNotificationStatus', sortable: true, label: 'Status', class: 'text-rigth hidden' },
            { key: 'contents', sortable: true, label: 'Contents', class: 'text-rigth hidden' },
           // { key: 'module', sortable: true, label: 'Module', class: 'text-rigth' },
           // { key: 'action', sortable: true, label: 'Action', class: 'text-rigth' },
            { key: 'notificationType', sortable: true, label: 'Notification Type', class: 'text-rigth' },
            { key: 'userName', sortable: true, label: 'User Name', class: 'text-rigth' },
        ],
      refTable:'NoticesTable'
    }
  },

  methods:{

    InputDateFrom($event){
        this.DateFrom = $event;
        this.getAllMessages();
    },
    InputDateTo($event){
        this.DateTo = $event;
        this.getAllMessages();
    },
    ChangeDropDownNotificationType(item){
        this.NotificationTypeModel = item ? item : {value:"",name:""};
        this.getAllMessages();
    },
    ChangeDropDownRecipientType(){

    },

    MessageOnCancel(){
        this.VisibleMessage = false;
    },

    ChangeDropDownStatus(item){
        this.StatusModel = item ? item : {value:"",name:""};
        this.getAllMessages();
    },

    getPatientValues(values){
      this.PatientModel = values;
      this.getAllMessages();
    },

    ChangeDropDownAction(){

    },

    ChangeDropDownModule(){

    },
    handleDblClick(){

    },
    pageChanged(page){
      this.currentPage = page;
      this.getAllMessages();
    },
    PerPageFunction(perpage){
      this.perPage = perpage;
      this.currentPage = 1;
      this.getAllMessages();
    },
    onFiltered(){

    },
    handleViewEvent(item){
        this.Message = item.contents;
        this.VisibleMessage = true;
    },
    onRowSelected(){

    },

    getAllMessages() {
      this.parameter.PageNumber = this.currentPage;
      this.parameter.PageSize = this.perPage;
      this.parameter.PatientCodeList = [];
      this.parameter.StatusList = [];
      this.parameter.NotificationTypeList = [];

      this.parameter.DateFrom = this.DateFrom;
      this.parameter.DateTo = this.DateTo;

      if(this.NotificationTypeModel && this.NotificationTypeModel.value){
        this.parameter.NotificationTypeList.push(this.NotificationTypeModel.value)
      }

      if(this.StatusModel && this.StatusModel.value){
        this.parameter.StatusList.push(this.StatusModel.value)
      }

      if(!this.IsFilterPatient){
        this.parameter.PatientCodeList.push(this.PatientCode);
      }else{
        this.parameter.PatientCodeList = this.PatientModel;
      }

      MessageHistory.getAllHistories(this.parameter)
      .then((response) => {
        if(response.status == '200' && response.data){
            this.items = response.data;
            this.totalRows =  this.items.length > 0 ? this.items[0].maxRows : 0;
            this.ShowMessageIsEmpty = this.items.length === 0 ;
            this.items.forEach(function(element) {
                element.patientNotificationStatus = element.status;
                if (element.sysDate) element.sysDate = Utils.formatterDateToString(element.sysDate);
            });
        }
      })
      .catch(error => {
        this.showResponseErrorMessage(error);
      });
    },
  },

  mounted(){
    this.getAllMessages();
  }

};
</script>


